import React, { useState } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { i18nIntl, isNotEmpty } from '../../lib/ep';

import ActionButton from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import CopyLink from '../builder/CopyLink';
import FloatingLayerPublic from '../front/FloatingLayerPublic';

const InstagramClaimButton = ({ sweep, ...props }) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const [ display_layer, setDisplayLayer ] = useState(false);

	const word = `WIN${sweep.id}`;

	if(!props.user_claim) {
		return(
			<>
				<ActionButton
					_fullclass="netButton submit hb_secondaryFont disabledButton"
					autotranslate={false}
				>{(isNotEmpty(sweep, 'claim_button')) ? sweep.claim_button : i18n("Claim your prize")}</ActionButton>

				<p style={{ paddingBlockStart:'0.5em' }}>
					<FormattedMessage
						id="The system to claim the prize on Instagram is disconnected."
					/>
				</p>
			</>
		)
	}

	return (
		<>
			<ActionButton
				_fullclass="netButton submit hb_secondaryFont"
				onClick={() => setDisplayLayer(true)}
				autotranslate={false}
			>{(isNotEmpty(sweep, 'claim_button')) ? sweep.claim_button : i18n("Claim your prize")}</ActionButton>

			{(display_layer) && (
				<FloatingLayerPublic
					backButton={() => setDisplayLayer(false)}
					enable_close={false}
					footer_buttons={<>
						<ActionButton
							onClick={() => setDisplayLayer(false)}
						>Close</ActionButton>
					</>}
				>
					<div>
						<p class="gui_force_bold">{i18n("Instructions to claim your prize")}</p>

						<p class="gui_not_in_top_tiny">{i18n("If you have been selected as a winner, please follow these steps")}:</p>

						<ul class="bulleted_list gui_not_in_top_small">
							<li class="gui_force_roman">
								<FormattedMessage
									id="{label} to our official Instagram account"
									values={{
										label:<strong>{`${i18n("Send a direct message")} (DM)`}</strong>,
									}}
								/>:
								<ActionLink
									_href={`https://instagram.com/${props.user_claim.substring(1)}`}
									_target='_blank'
									autotranslate={false}
									_class={{ other:'gui_force_bold' }}
									style={{
										'--link-text-transform':'none',
										padding:'0 0 3px',
									}}
								>{props.user_claim}</ActionLink>
							</li>

							<li class="gui_force_roman">
								<FormattedMessage
									id="Include the unique keyword{word}"
									values={{
										word:<>: <strong>{word}</strong> [<CopyLink
											copy_link={word}
										>Copy</CopyLink>]</>,
									}}
								/>
							</li>
						</ul>

						<p class="gui_not_in_top">{i18n("If you have not been selected as a winner, click the button below to close this window.")}</p>
					</div>
				</FloatingLayerPublic>
			)}
		</>
	)
};

export default injectIntl(InstagramClaimButton);